import React, {useEffect, useState} from 'react';
import Recipe from './Recipes.js';
import './App.css';

const App = () => {

  const APP_ID = "b709b8ec";
  const APP_KEY = "fc673c19a405d85c0f2b3e2a35b23c29";
  
  const [recipes, setRecipes] = useState([]);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("chicken");

  useEffect(() => {
    getRecipes();
  }, [query]);

  const getRecipes = async () => {
    const response = await fetch(
      `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}`);
      const data = await response.json();
      setRecipes(data.hits);      
    };

    const updateSearch = event => {
      setSearch(event.target.value);
    };

    const getSearch = event => {
      event.preventDefault();
      setQuery(search);
      setSearch("");
    };


  return(
    <div className="App">
      <h1>Recipes!</h1>
      <form onSubmit={getSearch} className="search-form">
        <input className="search-bar" type="text" value={search} onChange={updateSearch}/>

        <button className="search-button" type="submit">Search</button>
      </form>
      <div className="recipes">
      {recipes.map(recipe => (
        <Recipe key={recipe.recipe.label} 
        title={recipe.recipe.label} 
        ingredients ={recipe.recipe.ingredients}
        image={recipe.recipe.image} 
        calories={recipe.recipe.calories} />
      ))}
      </div>
    </div>
  )
}

export default App;
